import React from 'react';
// import InfiniteScroll from 'react-infinite-scroller';
import '../../../../styles/searchpage.css';
import '../../../../styles/landingPage.css';
import '../../../../styles/landingPage.css';
import '../../../../styles/artworks.css';
import '../../../../styles/common_elements.css';
import Button from 'react-bulma-components/lib/components/button';
import Modal from 'react-bulma-components/lib/components/modal';
import { Redirect } from 'react-router-dom';
// import ArtworkCard from '../../../cardHolders/artworksCard';
import ArtistsCard from '../../../cardHolders/artistsCard';
import Filter from '../../../../helpers/filter'
import querystring from 'qs';
import { observer, inject } from 'mobx-react';
import { Card, Image } from 'semantic-ui-react';
// import InfiniteScroll from 'react-infinite-scroll-component';
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateInputLength
} from "../../../../helpers/validationChecks";
import OB1 from '../../../Home/onboarding/onboarding1-modal'
import OB2 from '../../../Home/onboarding/onboarding2-modal'
import OB3 from '../../../Home/onboarding/onboarding3-modal';
import ReactGA from "react-ga";
const filterConfig = [
    {
        filterKey: "general", display: "General",
        choices: [
            { display: "Show me only artists", key: "1" }
        ]
    }
]

@observer
@inject('searchPageArtworksStore', 'commonStore', 'navigatorStore','authStore','userStore')
export default class searchResultspage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterState: false,
            artistList: false,
            search: false,
            uniqueContainerId: "container_" + new Date().getTime() + Math.random(),
        }

    }

    componentDidMount() {
        // if (localStorage.hasOwnProperty("userData")) {
        ReactGA.pageview('/Search artist action');
        console.log('[componentDidMount] srchpage ', this.props.match.params.search)
        var str = this.props.match.params.search;
        this.setState({
            search: str
        })
        if (localStorage.hasOwnProperty("userData")) {
            this.props.searchPageArtworksStore.getAllArtistsSearch({ search: str })
                .then((res) => {
                    console.log("[look at response]", res)
                    this.setState({
                        response: res.data,
                        artistList: res.data.data
                    }, function () {
                        console.log("[look at artworks state]", this.state.artworksList);
                        console.log(this.state.response)
                    })
                })

            this.props.userStore.pulluser().then((result) => {
                console.log("{this is pulled user}", result)
                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    formData.append("display_name", this.state.formInputs.display_name)
                    // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                    this.props.userStore.validateDisplayName(formData)
                        .then((response) => {
                            console.log(response)
                            if (response.error == "True") {
                                console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true,
                                    // formInputs: { ...this.state.formInputs, display_name: "" }
                                })
                                // this.props.navigatorStore.openErrorModal(response.data)
                                return;
                            }
                            else {
                                console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true
                                })
                            }
                        })
                        .catch((err => {
                            console.log("tell i am coming here at leats")
                            this.props.navigatorStore.openOB3Modal();
                            this.setState({
                                onboardingThreeIncomplete: true,



                            })
                        }));
                }

                if (result.data[0].display_name) {
                    if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                }

                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    console.log("profile null")
                    console.log("tell i am coming here at leats")
                    this.props.navigatorStore.openOB3Modal();
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    // this.state.makeOnboardingThreeIncomplete()
                }

            })
        } else {
            this.setState({ shareUrl: true },
                () => {

                    this.props.searchPageArtworksStore.getAllArtistsSearch({ search: str })
                        .then((res) => {
                            console.log("[look at response]", res)
                            this.setState({
                                response: res.data,
                                artistList: res.data.data
                            }, function () {
                                console.log("[look at artworks state]", this.state.artworksList);
                                console.log(this.state.response)
                            })
                        })
                }
            )
        }

        console.log(str)

        // }

        document.addEventListener('scroll', this.trackScrolling);
    }

    componentWillReceiveProps(nextProps) {
        if (localStorage.hasOwnProperty("userData")) {
            this.setState({
                loggedIn: true
            })
        }
        console.log('[componentWillReceiveProps] srchpage ', nextProps.match.params.search)
        var str = nextProps.match.params.search;
        let searchableString = str;
        console.log({ matcher: searchableString != this.state.search, inState: this.state.search, iHave: searchableString })
        if (!!this.state.search && searchableString != this.state.search) {
            this.setState({
                search: searchableString
            }, () => {
                this.searchOnline(searchableString);
            })
            // document.addEventListener('scroll', this.trackScrolling);
        }
        else setTimeout(() => {
            var str = nextProps.match.params.id;
            console.log('[mounted] componentWillReceiveProps srchpage nextProps hihihuhu ', this.state.shareUrl)
            // debugger;
            // if (this.state.shareUrl || str != this.state.artistId) {

            if (this.state.shareUrl && (!!this.props.authStore.loginDone || this.props.authStore.RegisterSuccess)) {
                console.log('[mounted] srchpage next hihihuhu', nextProps.match.params.id)

                this.setState({
                    shareUrl: false,

                }, () => {
                    console.log('[mounted] srchpage next hihihuhu', nextProps.match.params.id, this.props.authStore.RegisterSuccess, localStorage.getItem("just_registered"))
                    if (localStorage.hasOwnProperty("userData")) {
                        // window.location.reload()
                        this.searchOnline(searchableString);
                        if (this.props.authStore.onboardingThreeIncomplete || this.props.authStore.onboardingTwoIncomplete) {
                            console.log("hihi tell i am coming here at leats")
                            this.props.navigatorStore.openOB3Modal();

                        }
                        else if (this.props.authStore.RegisterSuccess || localStorage.getItem("just_registered")) {
                            localStorage.removeItem("just_registered");
                            this.props.navigatorStore.openOB1Modal();

                        }
                    }
                })
            }
        }, 1000)
    }



    searchOnline(str) {
        this.props.searchPageArtworksStore.getAllArtistsSearch({ search: this.state.search })
            .then((res) => {
                console.log("[look at response]", res)
                this.setState({
                    response: res.data,
                    artistList: res.data.data
                }, function () {
                    console.log("[look at artworks state]", this.state.artworksList);
                    console.log(this.state.response)
                })
            })

    }

    componentWillUnmount() {
        console.log("unmounted")
        document.removeEventListener('scroll', this.trackScrolling);
        this.props.searchPageArtworksStore.resetPagination()
        this.props.searchPageArtworksStore.resetSearchKeyword()
    }

    trackScrolling = () => {
        const wrappedElement = document.getElementById(this.state.uniqueContainerId);
        let reachedPageEndNow = this.isBottom(wrappedElement);
        console.log('[trackScroll] ', { reachedPageEndNow, reachedPageEnd: this.state.reachedPageEnd });
        if (this.isBottom(wrappedElement)) {
            console.log('[trackScroll] FAKE ');
        };
        if ((reachedPageEndNow && !this.state.reachedPageEnd) || (!reachedPageEndNow && this.state.reachedPageEnd)) {
            this.setState({ reachedPageEnd: reachedPageEndNow })
            reachedPageEndNow && console.log('[trackScroll] REAL ');
            if (reachedPageEndNow) {
                if (localStorage.hasOwnProperty("userData")) {
                    this.loadFunc()
                }
            }
        }
    };

    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    }

    handelFilterChangeMaster(item) {
        console.log("artist filter looks like", item)
        var self = this
        this.setState({
            filterState: item,
            // showFilters: false
        }, function () {
            let filterQuery = "";
            if (item.general[1]) {
                filterQuery = filterQuery.concat(`artists=True&`)
            }
            filterQuery = filterQuery.concat(`search=${this.state.search}&`)

            let queryString = querystring.stringify(filterQuery);
            console.log("[queryString]", filterQuery)
            this.props.searchPageArtworksStore.getAllArtistsSearch({ search: this.state.search, artists: item.general[1] ? "True" : "False" })
                .then((res) => {
                    console.log(res)
                    this.setState({
                        filter : item.general[1] ? true : false,
                        response: res.data,
                        artistList: res.data.data
                    }, function () {
                        console.log("[look at artworks state]", this.state.artworksList)
                    })
                })

        })
    }
    handleLoadMoreBtnClick() {
        this.props.navigatorStore.openSignInModal()
    }
    // handleClearButton()
    loadFunc() {
        console.log("loading more");
        // let filterQuery = filterQuery.concat(`search=${this.state.search}&`)

        if(localStorage.hasOwnProperty("userData") ){ this.props.searchPageArtworksStore.loadmoreArtistsSearch();
        this.props.searchPageArtworksStore.getAllArtistsSearch({ search: this.state.search, artists : (this.state.filter) ? "True" : "False" }, true)
            .then((res) => {

                if (this.state.artistList) {
                    var joined = this.state.artistList.concat(res.data.data)
                    this.setState({
                        response: res.data,
                        artistList: joined
                    }, function () {
                        console.log(this.state.response.count)
                    })
                }
            })
        }

    }
    render() {
        return (

            <div className="searchpage-container" id="scrollableDiv" >
                <div className="searchpage-content-container">

                    <div className="searchpage-heading">
                        <div className="heading-btn-row filter-heading">
                            <div className="col-md-6 pl-0">
                                <h3 className="heading-left-text">Search Result for {`"${this.state.search}"`}</h3>
                                <hr className="line-category-name"></hr>
                            </div>
                            <Filter handelFilterChangeMaster={this.handelFilterChangeMaster.bind(this)} currentOverallFilterState={this.state.filterState} filterConfig={filterConfig} />
                        </div>

                    </div>
                    <OB1/>
                    <OB2/>
                    <OB3/>
                    <div className="mt-15 mb-15 pb-15" id={this.state.uniqueContainerId}>
                        {/* <InfiniteScroll className="row mt-15 mb-15 pb-15"
                            dataLength={(this.state.response) ? this.state.response.count : 0}//This is important field to render the next data
                            next={this.loadFunc.bind(this)}
                            hasMore={true}
                            loader={<h4>Loading...</h4>}
                            endMessage={
                                <p style={{ textAlign: 'center' }}>
                                    <b>Yay! You have seen it all</b>
                                </p>

                            }
                        scrollableTarget={document.getElementById('scrollableDiv')}
                        > */}{
                            (this.state.artistList && !this.state.artistList.length) ?  <div className="gray-category-description">No results to show</div> :
                        <ArtistsCard artistData={this.state.artistList} />
                        }
                        {/* </InfiniteScroll> */}

                    </div>

                </div>

                <div className="col-md-12 text-center" style={{ display: ((!localStorage.hasOwnProperty("userData") && !this.state.loggedIn) ? "" : "none") }}>
                    <Button id="load-more-artworks-btn" onClick={this.handleLoadMoreBtnClick.bind(this)}
                        className="masterpieces-tertiary-black-button btn-black btn-p10 mb-25">LOG IN TO SEE MORE</Button>
                </div>
            </div>

        )
    }
}




// WEBPACK FOOTER //
// ./src/components/Home/profile/search/searchPageArtists.js